import { Badge, makeStyles, Title1, tokens } from '@fluentui/react-components';
import { FC } from 'react';

const useStyles = makeStyles({
  cardBigNumber: {
    color: tokens.colorBrandForeground1,
    fontSize: '3rem',
  },
  cardBigNumberContainer: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: tokens.spacingVerticalS,
  },
  badge: {
    position: 'absolute',
    top: '2rem',
    left: '-1rem',
    padding: `${tokens.spacingVerticalM} ${tokens.spacingHorizontalS}`,
    boxShadow: tokens.shadow4,
    borderRadius: tokens.borderRadiusMedium,
    backgroundColor: tokens.colorNeutralBackground1,
    color: tokens.colorNeutralForeground1,
  },
});

/**
 * The custom circular progress for "Submission Readiness".
 */
const CircularProgress: FC<{ percentage: number }> = ({ percentage }) => {
  const radius = 40;
  const strokeWidth = 4;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (percentage / 100) * circumference;

  const classes = useStyles();

  return (
    <div className="relative !w-48 !h-48 flex items-center justify-center">
      <svg className="transform -rotate-90" viewBox="0 0 100 100">
        {/* Background Circle */}
        <circle cx="50" cy="50" r={radius} fill="none" stroke="#242424" strokeWidth={strokeWidth} opacity="0.2" />
        {/* Progress Circle */}
        <circle
          cx="50"
          cy="50"
          r={radius}
          fill="none"
          stroke="#357457"
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
        />
      </svg>
      {/* Percentage Text */}
      <div className={classes.cardBigNumberContainer}>
        <Title1 className={classes.cardBigNumber}>{percentage}%</Title1>
      </div>

      <Badge className={classes.badge} appearance="filled" color="informative">
        7 incomplete files
      </Badge>
    </div>
  );
};

export default CircularProgress;
